import React, { useEffect, useState } from "react";
import Footer from "../../stories/Footer";
import Header from "../../stories/Header";
import classes from "./ContactUsPage.module.css";
import { Row, Col, Container, Form } from "react-bootstrap";
import Button from "../../stories/Button/Button";
import Input from "../../stories/Input";
import {
  Form as ReactRouterForm,
  useActionData,
  useLocation,
  useNavigation,
  useRouteLoaderData,
} from "react-router-dom";
import TextArea from "../../stories/TextArea";
import { toast } from "react-toastify";
import {
  falsyArray,
  formRegEx,
  formRegExReplacer,
  validateEmail,
} from "../../config/apiUrl";
import { useDispatch } from "react-redux";
import { saveLocation } from "../../redux/common/commonSlice";

const ContactUsPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const navigation = useNavigation();

  return (
    <>
      <Header />
      <section>
        <Container className={classes.container}>
          <Row>
            <Col lg={8}>
              <h2 className={classes.detail_heading}>CONTACT US</h2>
              <div className={classes.detailForm_main}>
                <ReactRouterForm
                  method="post"
                  action="/contact-us"
                  id="react-router-form"
                >
                  <Row className={classes.detailForm_row}>
                    <Col lg={6}>
                      <Input
                        type={"text"}
                        placeholder="First Name"
                        name={"firstName"}
                      />
                    </Col>
                    <Col lg={6}>
                      <Input
                        type={"text"}
                        placeholder="Last Name"
                        name={"lastName"}
                      />
                    </Col>
                  </Row>
                  <Row className={classes.detailForm_row1}>
                    <Col lg={6}>
                      <Input type={"text"} placeholder="Phone" name={"phone"} />
                    </Col>
                    <Col lg={6}>
                      <Input
                        type={"email"}
                        placeholder="Email"
                        name={"email"}
                      />
                    </Col>
                  </Row>

                  <Row className={classes.detailForm_row1}>
                    <Col lg={12}>
                      <TextArea
                        placeholder={"Description"}
                        name="description"
                        rows={6}
                      />
                    </Col>
                  </Row>
                  <Row className={classes.detailForm_row1}>
                    <Button
                      label={
                        navigation?.state === "submitting"
                          ? "Please Wait..."
                          : "Sumbit"
                      }
                      disabled={navigation?.state === "submitting"}
                      className={classes.publish_btn}
                    />
                  </Row>
                </ReactRouterForm>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default ContactUsPage;

export async function action({ request }) {
  const formData = await request.formData();
  const params = {
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    phone: formData.get("phone"),
    email: formData.get("email"),
    description: formData.get("description"),
  };

  // validate email
  if (!validateEmail(params?.email))
    return toast.warn("Please enter a valid email address");

  // validateData
  for (let key in params)
    if (falsyArray.includes(params[key]))
      return toast.warn(
        `${key.replace(formRegEx, formRegExReplacer)} can not be empty.`
      );

  // API

  document.getElementById("react-router-form").reset();
}
